module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABCUlEQVQ4ja2UMU4DUQxEZxFwAE5ACQ0cAZBYjgB34wApOALNliAqqKIEqCDUUUizoXjIyF+QaO1NJEaytPKfGfuv7C+gK2rgGngGWo8Xz9VdmtXEAdDQj8a5nUYnwGwNk4KZa5aMDoFpIogKTEtnZlIBdwFxAux5TAKOaSszOk/af/JCFo8Jr96WdKUYR5JuJSHpOOFdmtFZQjDs95zrx8NnJMIY2AV2fKYitFuS2qTSWNJC0pekUdaSGX2s0Xof3szo4R+MGjMaJIQq+F7FzSYD+R5w7stAlhX5DIjZiljetEtLe5qYdcG4pgmfkeiaf2Gc8BkpYf/swh+xV2ABzIGh5+zMOL8a0DcnXB5Ffje5+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/contract-signature/zhu.png
// module id = 1305
// module chunks = 61